<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="epigraph"><span><i>“Sir,” the Aide said to the Commanding</i></span></p>
<p class="center"><span><i>Officer, “G1, G2, G3, and G4 concur in the opinion that the proposed plan for the operation has an 85 percent chance of success, with acceptable losses.”</i></span></p>
<p class="center" style="margin-top:20px;"><span><i>From this and other missions forty-four of our aircraft are missing.</i></span></p>
<p class="center" style="margin-top:20px;"><span><i>The National Safety Council predicted yesterday that there would be five hundred and fifty-eight fatal traffic accidents over this forthcoming holiday weekend.</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-epigraph.vue?cb0926fc